<template>
  <div class="ui-kit-v2-stepper-display" :show-nav-buttons="showNavButtons">
    <div class="ui-kit-v2-stepper-display__title">
      {{ title }}
    </div>
    <div class="ui-kit-v2-stepper-display__progress-bar">
      <div class="ui-kit-v2-stepper-display__progress-bar-background"></div>
      <div
        class="ui-kit-v2-stepper-display__progress-bar-foreground"
        :style="{ width: `${progressPercent}%` }"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StepperDisplay',
  props: {
    /**
     * Текущий индекс шага
     */
    currentStepIdx: {
      type: Number,
      default: 0
    },
    /**
     * Список шагов
     */
    steps: {
      type: Array,
      default: () => {
        [];
      }
    },
    /**
     * Отображение кнопок
     */
    showNavButtons: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    progressPercent() {
      return ((this.currentStepIdx + 1) / this.steps.length) * 100;
    },
    title() {
      const questionItems = this.steps.filter(item => item.component === 'Question');
      const isAdmin = questionItems.length > 0

      if (isAdmin) {
        if (this.steps?.[this.currentStepIdx]?.component === 'Description') {
          return 'Описание';
        } else if (this.steps?.[this.currentStepIdx]?.component === 'Results') {
          return 'Завершение';
        } else {
          return `${this.currentStepIdx} из ${questionItems.length} вопросов`;
        }
      }
      else {
        return `${this.currentStepIdx + 1} из ${this.steps.length} вопросов`;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'src/style/utils';

.ui-kit-v2-stepper-display {
  $screen-sm: 600px;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  max-width: unset;

  &__title {
    margin-bottom: 8px;
    color: $ui-light-grey-4-5-contrast;
    font-size: 14px;
  }

  &__progress-bar {
    position: relative;
    width: 100%;
    height: 4px;

    &-background {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #dfe0eb;
      border-radius: 12px;
    }

    &-foreground {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #6979f8;
      border-radius: 12px;
    }
  }
}

.ui-kit-v2-stepper-display[show-nav-buttons] {
  $screen-sm: 600px;

  max-width: 164px;

  @include media($screen-sm) {
    width: 100%;
    max-width: unset;
    margin-bottom: 12px;
  }
}
</style>
